<!--运输方式-->
<template>
  <el-form ref="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <h3 style="padding-left:15px;">运输方式</h3>
      <el-row>
        <el-col :xs="24" :sm="24" style="padding:15px;">
          <el-link style="margin-top:8px;" type="danger" disabled>
            {{ msg('在入仓出仓中装袋时，填写了运输方式，默认是不会更新，需要在这里设置是否更新') }}
          </el-link>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('是否更新运输方式')" label-width="150">
            <el-radio v-model="needUpdateTransport" label="1">是</el-radio>
            <el-radio v-model="needUpdateTransport" label="0">否</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingTransportation",
  data() {
    return {
      xgroup: 'TRANSPORT_GROUP',  //电子秤group
      needUpdateTransport: 0, // 是否更新运输方式
      needUpdateTransportObj: null, // 是否更新运输方式
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      if (data.length > 0) {
        this.needUpdateTransport = data[0].xvalue;
        this.needUpdateTransportObj = data[0];
      }
    },
    update() {
      let datas = [];
      if (this.needUpdateTransportObj) {
        this.needUpdateTransportObj.xvalue = this.needUpdateTransport || 0;
        datas.push(this.needUpdateTransportObj);
      } else {
        this.needUpdateTransportObj = {
          id: null,
          xkey: this.xgroup,
          owner: null,
          xgroup: this.xgroup,
          xvalue: this.needUpdateTransport || 0,
          xtype: 1
        }
        datas.push(this.needUpdateTransportObj);
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>